import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import { Camera } from 'lucide-react';

const serviceData = {
  id: 'video',
  title: 'Vidéosurveillance',
  description: 'Solutions complètes de vidéosurveillance',
  icon: Camera,
  image: '/Videosurveillance.jpg', // Updated path
  longDescription: [
    'Nos systèmes de vidéosurveillance offrent une protection visuelle complète de vos locaux. Nous concevons et installons des solutions adaptées à vos besoins spécifiques de sécurité et de surveillance.',
    'Grâce aux technologies les plus récentes, nous vous garantissons une surveillance efficace 24/7 avec des images haute définition et des fonctionnalités avancées d\'analyse vidéo.'
  ],
  features: [
    'Caméras HD/4K',
    'Vision nocturne',
    'Enregistrement sur serveur sécurisé',
    'Analyse vidéo intelligente',
    'Accès à distance',
    'Détection de mouvement'
  ],
  benefits: [
    'Surveillance continue 24/7',
    'Dissuasion efficace',
    'Protection des biens et personnes',
    'Preuves vidéo en cas d\'incident',
    'Interface utilisateur intuitive'
  ]
};

const Videosurveillance = () => {
  return <ServiceTemplate service={serviceData} />;
};

export default Videosurveillance;
